const worldCountries = [
  {
    regions: ['EU', 'EUS'],
    code: 'MLT',
    id: 'EU_MLT',
    name: 'Malta'
  },
  {
    regions: ['EU', 'EUS'],
    code: 'AND',
    id: 'EU_AND',
    name: 'Andorra'
  },
  {
    regions: ['NA', 'CBN'],
    code: 'ATG',
    id: 'NA_ATG',
    name: 'Antigua and Barbuda'
  },
  {
    regions: ['NA', 'CBN'],
    code: 'BRB',
    id: 'NA_BRB',
    name: 'Barbados'
  },
  {
    regions: ['NA', 'CBN'],
    code: 'DMA',
    id: 'NA_DMA',
    name: 'Dominica'
  },
  {
    regions: ['NA', 'CBN'],
    code: 'GRD',
    id: 'NA_GRD',
    name: 'Grenada'
  },
  {
    regions: ['NA', 'CBN'],
    code: 'KNA',
    id: 'NA_KNA',
    name: 'Saint Kitts and Nevis'
  },
  {
    regions: ['NA', 'CBN'],
    code: 'VTC',
    id: 'NA_VTC',
    name: 'Saint Vincent and the Grenadines'
  },
  {
    regions: ['NA', 'CBN'],
    code: 'LCA',
    id: 'NA_LCA',
    name: 'Saint Lucia'
  },
  {
    regions: ['AS'],
    code: 'BHR',
    id: 'AS_BHR',
    name: 'Bahrain'
  },
  {
    regions: ['AS'],
    code: 'MDV',
    id: 'AS_MDV',
    name: 'Maldives'
  },
  {
    regions: ['AS'],
    code: 'SGP',
    id: 'AS_SGP',
    name: 'Singapore'
  },
  {
    regions: ['AF'],
    code: 'CPV',
    id: 'AF_CPV',
    name: 'Cape Verde'
  },
  {
    regions: ['AF'],
    code: 'COM',
    id: 'AF_COM',
    name: 'Comoros'
  },
  {
    regions: ['AF'],
    code: 'MUS',
    id: 'AF_MUS',
    name: 'Mauritius'
  },
  {
    regions: ['AF'],
    code: 'STP',
    id: 'AF_STP',
    name: 'Sao Tome and Principe'
  },
  {
    regions: ['AF'],
    code: 'SYC',
    id: 'AF_SYC',
    name: 'Seychelles'
  },
  {
    regions: ['OC'],
    code: 'KIR',
    id: 'OC_KIR',
    name: 'Kiribati'
  },
  {
    regions: ['OC'],
    code: 'MHL',
    id: 'OC_MHL',
    name: 'Marshall Islands'
  },
  {
    regions: ['OC'],
    code: 'FSM',
    id: 'OC_FSM',
    name: 'Federated States of Micronesia'
  },
  {
    regions: ['OC'],
    code: 'NRU',
    id: 'OC_NRU',
    name: 'Nauru'
  },
  {
    regions: ['OC'],
    code: 'PLW',
    id: 'OC_PLW',
    name: 'Palau'
  },
  {
    regions: ['OC', 'APAC'],
    code: 'WSM',
    id: 'OC_WSM',
    name: 'Samoa'
  },
  {
    regions: ['EU', 'EUS'],
    code: 'SMR',
    id: 'EU_SMR',
    name: 'San Marino'
  },
  {
    regions: ['EU'],
    code: 'MCO',
    id: 'EU_MCO',
    name: 'Monaco'
  },
  {
    regions: ['EU', 'EUS'],
    code: 'VAT',
    id: 'EU_VAT',
    name: 'Vatican'
  },
  {
    regions: ['NA', 'CBN'],
    code: 'BHS',
    id: 'NA_BHS',
    name: 'Bahamas'
  },
  {
    regions: ['NA'],
    code: 'BLZ',
    id: 'NA_BLZ',
    name: 'Belize'
  },
  {
    regions: ['NA', 'OECD'],
    code: 'CAN',
    id: 'NA_CAN',
    name: 'Canada'
  },
  {
    regions: ['NA'],
    code: 'CRI',
    id: 'NA_CRI',
    name: 'Costa Rica'
  },
  {
    regions: ['NA', 'CBN'],
    code: 'CUB',
    id: 'NA_CUB',
    name: 'Cuba'
  },
  {
    regions: ['NA', 'CBN'],
    code: 'DOM',
    id: 'NA_DOM',
    name: 'Dominican Republic'
  },
  {
    regions: ['NA', 'NRD'],
    code: 'GRL',
    id: 'NA_GRL',
    name: 'Greenland'
  },
  {
    regions: ['NA'],
    code: 'GTM',
    id: 'NA_GTM',
    name: 'Guatemala'
  },
  {
    regions: ['NA'],
    code: 'HND',
    id: 'NA_HND',
    name: 'Honduras'
  },
  {
    regions: ['EU', 'NA', 'CBN'],
    code: 'HTI',
    id: 'NA_HTI',
    name: 'Haiti'
  },
  {
    regions: ['NA', 'CBN'],
    code: 'JAM',
    id: 'NA_JAM',
    name: 'Jamaica'
  },
  {
    regions: ['NA', 'OECD'],
    code: 'MEX',
    id: 'NA_MEX',
    name: 'Mexico'
  },
  {
    regions: ['NA'],
    code: 'NIC',
    id: 'NA_NIC',
    name: 'Nicaragua'
  },
  {
    regions: ['NA', 'CBN'],
    code: 'PRI',
    id: 'NA_PRI',
    name: 'Puerto Rico'
  },
  {
    regions: ['NA'],
    code: 'PAN',
    id: 'NA_PAN',
    name: 'Panama'
  },
  {
    regions: ['NA'],
    code: 'SLV',
    id: 'NA_SLV',
    name: 'El Salvador'
  },
  {
    regions: ['NA', 'OECD'],
    code: 'USA',
    id: 'NA_USA',
    name: 'United States'
  },
  {
    regions: ['NA', 'CBN'],
    code: 'TTO',
    id: 'NA_TTO',
    name: 'Trinidad and Tobago'
  },
  {
    regions: ['SA'],
    code: 'ARG',
    id: 'SA_ARG',
    name: 'Argentina'
  },
  {
    regions: ['SA'],
    code: 'BRA',
    id: 'SA_BRA',
    name: 'Brazil'
  },
  {
    regions: ['SA'],
    code: 'BOL',
    id: 'SA_BOL',
    name: 'Bolivia'
  },
  {
    regions: ['OECD', 'SA'],
    code: 'CHL',
    id: 'SA_CHL',
    name: 'Chile'
  },
  {
    regions: ['SA'],
    code: 'COL',
    id: 'SA_COL',
    name: 'Colombia'
  },
  {
    regions: ['SA'],
    code: 'ECU',
    id: 'SA_ECU',
    name: 'Ecuador'
  },
  {
    regions: ['SA'],
    code: 'FLK',
    id: 'SA_FLK',
    name: 'Falkland Islands'
  },
  {
    regions: ['SA'],
    code: 'GUY',
    id: 'SA_GUY',
    name: 'Guyana'
  },
  {
    regions: ['SA'],
    code: 'PER',
    id: 'SA_PER',
    name: 'Peru'
  },
  {
    regions: ['SA'],
    code: 'PRY',
    id: 'SA_PRY',
    name: 'Paraguay'
  },
  {
    regions: ['SA'],
    code: 'SUR',
    id: 'SA_SUR',
    name: 'Suriname'
  },
  {
    regions: ['SA'],
    code: 'URY',
    id: 'SA_URY',
    name: 'Uruguay'
  },
  {
    regions: ['SA'],
    code: 'VEN',
    id: 'SA_VEN',
    name: 'Venezuela'
  },
  {
    regions: ['AS'],
    code: 'AFG',
    id: 'AS_AFG',
    name: 'Afghanistan'
  },
  {
    regions: ['ME', 'AS'],
    code: 'ARE',
    id: 'AS_ARE',
    name: 'United Arab Emirates'
  },
  {
    regions: ['AS'],
    code: 'ARM',
    id: 'AS_ARM',
    name: 'Armenia'
  },
  {
    regions: ['AS'],
    code: 'AZE',
    id: 'AS_AZE',
    name: 'Azerbaijan'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'BGD',
    id: 'AS_BGD',
    name: 'Bangladesh'
  },
  {
    regions: ['EU', 'EUW'],
    code: 'LI',
    id: 'EU_LI',
    name: 'Liechtenstein'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'BRN',
    id: 'AS_BRN',
    name: 'Brunei Darussalam'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'BTN',
    id: 'AS_BTN',
    name: 'Bhutan'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'CHN',
    id: 'AS_CHN',
    name: 'China'
  },
  {
    regions: ['AS', 'EUS'],
    code: 'CYN',
    id: 'AS_CYN',
    name: 'Northern Cyprus'
  },
  {
    regions: ['AS', 'EUS'],
    code: 'CYP',
    id: 'AS_CYP',
    name: 'Cyprus'
  },
  {
    regions: ['AS'],
    code: 'GEO',
    id: 'AS_GEO',
    name: 'Georgia'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'IDN',
    id: 'AS_IDN',
    name: 'Indonesia'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'IND',
    id: 'AS_IND',
    name: 'India'
  },
  {
    regions: ['ME', 'AS'],
    code: 'IRN',
    id: 'AS_IRN',
    name: 'Iran'
  },
  {
    regions: ['ME', 'AS'],
    code: 'IRQ',
    id: 'AS_IRQ',
    name: 'Iraq'
  },
  {
    regions: ['ME', 'OECD', 'AS'],
    code: 'ISR',
    id: 'AS_ISR',
    name: 'Israel'
  },
  {
    regions: ['ME', 'AS'],
    code: 'JOR',
    id: 'AS_JOR',
    name: 'Jordan'
  },
  {
    regions: ['OECD', 'AS', 'APAC'],
    code: 'JPN',
    id: 'AS_JPN',
    name: 'Japan'
  },
  {
    regions: ['AS'],
    code: 'KAZ',
    id: 'AS_KAZ',
    name: 'Kazakhstan'
  },
  {
    regions: ['AS'],
    code: 'KGZ',
    id: 'AS_KGZ',
    name: 'Kyrgyzstan'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'KHM',
    id: 'AS_KHM',
    name: 'Cambodia'
  },
  {
    regions: ['OECD', 'AS', 'APAC'],
    code: 'KOR',
    id: 'AS_KOR',
    name: 'Republic of Korea'
  },
  {
    regions: ['ME', 'AS'],
    code: 'KWT',
    id: 'AS_KWT',
    name: 'Kuwait'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'LAO',
    id: 'AS_LAO',
    name: 'Lao PDR'
  },
  {
    regions: ['ME', 'AS'],
    code: 'LBN',
    id: 'AS_LBN',
    name: 'Lebanon'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'LKA',
    id: 'AS_LKA',
    name: 'Sri Lanka'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'MNG',
    id: 'AS_MNG',
    name: 'Mongolia'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'MYS',
    id: 'AS_MYS',
    name: 'Malaysia'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'MMR',
    id: 'AS_MMR',
    name: 'Myanmar'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'NPL',
    id: 'AS_NPL',
    name: 'Nepal'
  },
  {
    regions: ['ME', 'AS'],
    code: 'OMN',
    id: 'AS_OMN',
    name: 'Oman'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'PAK',
    id: 'AS_PAK',
    name: 'Pakistan'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'PHL',
    id: 'AS_PHL',
    name: 'Philippines'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'PRK',
    id: 'AS_PRK',
    name: 'Dem. Rep. Korea'
  },
  {
    regions: ['AS'],
    code: 'PSX',
    id: 'AS_PSX',
    name: 'Palestine'
  },
  {
    regions: ['ME', 'AS'],
    code: 'QAT',
    id: 'AS_QAT',
    name: 'Qatar'
  },
  {
    regions: ['ME', 'AS'],
    code: 'SAU',
    id: 'AS_SAU',
    name: 'Saudi Arabia'
  },
  {
    regions: ['ME', 'AS'],
    code: 'SYR',
    id: 'AS_SYR',
    name: 'Syria'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'THA',
    id: 'AS_THA',
    name: 'Thailand'
  },
  {
    regions: ['AS'],
    code: 'TJK',
    id: 'AS_TJK',
    name: 'Tajikistan'
  },
  {
    regions: ['AS'],
    code: 'TKM',
    id: 'AS_TKM',
    name: 'Turkmenistan'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'TLS',
    id: 'AS_TLS',
    name: 'Timor-Leste'
  },
  {
    regions: ['ME', 'OECD', 'AS', 'EUW', 'EUS'],
    code: 'TUR',
    id: 'AS_TUR',
    name: 'Turkey'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'TWN',
    id: 'AS_TWN',
    name: 'Taiwan'
  },
  {
    regions: ['AS'],
    code: 'UZB',
    id: 'AS_UZB',
    name: 'Uzbekistan'
  },
  {
    regions: ['AS', 'APAC'],
    code: 'VNM',
    id: 'AS_VNM',
    name: 'Vietnam'
  },
  {
    regions: ['ME', 'AS'],
    code: 'YEM',
    id: 'AS_YEM',
    name: 'Yemen'
  },
  {
    regions: ['AF'],
    code: 'AGO',
    id: 'AF_AGO',
    name: 'Angola'
  },
  {
    regions: ['AF'],
    code: 'BDI',
    id: 'AF_BDI',
    name: 'Burundi'
  },
  {
    regions: ['AF'],
    code: 'BEN',
    id: 'AF_BEN',
    name: 'Benin'
  },
  {
    regions: ['AF'],
    code: 'BFA',
    id: 'AF_BFA',
    name: 'Burkina Faso'
  },
  {
    regions: ['AF'],
    code: 'BWA',
    id: 'AF_BWA',
    name: 'Botswana'
  },
  {
    regions: ['AF'],
    code: 'CAF',
    id: 'AF_CAF',
    name: 'Central African Republic'
  },
  {
    regions: ['AF'],
    code: 'CIV',
    id: 'AF_CIV',
    name: "C\u00f4te d'Ivoire"
  },
  {
    regions: ['AF'],
    code: 'CMR',
    id: 'AF_CMR',
    name: 'Cameroon'
  },
  {
    regions: ['AF'],
    code: 'COD',
    id: 'AF_COD',
    name: 'Democratic Republic of the Congo'
  },
  {
    regions: ['AF'],
    code: 'COG',
    id: 'AF_COG',
    name: 'Republic of Congo'
  },
  {
    regions: ['ME', 'AF', 'NAF'],
    code: 'EGY',
    id: 'AF_EGY',
    name: 'Egypt'
  },
  {
    regions: ['AF'],
    code: 'ERI',
    id: 'AF_ERI',
    name: 'Eritrea'
  },
  {
    regions: ['AF'],
    code: 'ETH',
    id: 'AF_ETH',
    name: 'Ethiopia'
  },
  {
    regions: ['AF'],
    code: 'GAB',
    id: 'AF_GAB',
    name: 'Gabon'
  },
  {
    regions: ['AF'],
    code: 'DJI',
    id: 'AF_DJI',
    name: 'Djibouti'
  },
  {
    regions: ['AF', 'NAF'],
    code: 'DZA',
    id: 'AF_DZA',
    name: 'Algeria'
  },
  {
    regions: ['AF'],
    code: 'GHA',
    id: 'AF_GHA',
    name: 'Ghana'
  },
  {
    regions: ['AF'],
    code: 'GIN',
    id: 'AF_GIN',
    name: 'Guinea'
  },
  {
    regions: ['AF'],
    code: 'GMB',
    id: 'AF_GMB',
    name: 'The Gambia'
  },
  {
    regions: ['AF'],
    code: 'KEN',
    id: 'AF_KEN',
    name: 'Kenya'
  },
  {
    regions: ['AF'],
    code: 'GNB',
    id: 'AF_GNB',
    name: 'Guinea-Bissau'
  },
  {
    regions: ['AF'],
    code: 'GNQ',
    id: 'AF_GNQ',
    name: 'Equatorial Guinea'
  },
  {
    regions: ['AF'],
    code: 'LBR',
    id: 'AF_LBR',
    name: 'Liberia'
  },
  {
    regions: ['AF', 'NAF'],
    code: 'LBY',
    id: 'AF_LBY',
    name: 'Libya'
  },
  {
    regions: ['AF'],
    code: 'LSO',
    id: 'AF_LSO',
    name: 'Lesotho'
  },
  {
    regions: ['AF', 'NAF'],
    code: 'MAR',
    id: 'AF_MAR',
    name: 'Morocco'
  },
  {
    regions: ['AF'],
    code: 'MDG',
    id: 'AF_MDG',
    name: 'Madagascar'
  },
  {
    regions: ['AF'],
    code: 'MLI',
    id: 'AF_MLI',
    name: 'Mali'
  },
  {
    regions: ['AF'],
    code: 'MOZ',
    id: 'AF_MOZ',
    name: 'Mozambique'
  },
  {
    regions: ['AF'],
    code: 'NAM',
    id: 'AF_NAM',
    name: 'Namibia'
  },
  {
    regions: ['AF'],
    code: 'MRT',
    id: 'AF_MRT',
    name: 'Mauritania'
  },
  {
    regions: ['AF'],
    code: 'MWI',
    id: 'AF_MWI',
    name: 'Malawi'
  },
  {
    regions: ['AF'],
    code: 'RWA',
    id: 'AF_RWA',
    name: 'Rwanda'
  },
  {
    regions: ['AF'],
    code: 'SAH',
    id: 'AF_SAH',
    name: 'Western Sahara'
  },
  {
    regions: ['AF'],
    code: 'SDN',
    id: 'AF_SDN',
    name: 'Sudan'
  },
  {
    regions: ['AF'],
    code: 'NGA',
    id: 'AF_NGA',
    name: 'Nigeria'
  },
  {
    regions: ['AF'],
    code: 'NER',
    id: 'AF_NER',
    name: 'Niger'
  },
  {
    regions: ['AF'],
    code: 'SDS',
    id: 'AF_SDS',
    name: 'South Sudan'
  },
  {
    regions: ['AF'],
    code: 'SEN',
    id: 'AF_SEN',
    name: 'Senegal'
  },
  {
    regions: ['AF'],
    code: 'SLE',
    id: 'AF_SLE',
    name: 'Sierra Leone'
  },
  {
    regions: ['AF'],
    code: 'SOL',
    id: 'AF_SOL',
    name: 'Somaliland'
  },
  {
    regions: ['AF'],
    code: 'SOM',
    id: 'AF_SOM',
    name: 'Somalia'
  },
  {
    regions: ['AF'],
    code: 'TCD',
    id: 'AF_TCD',
    name: 'Chad'
  },
  {
    regions: ['AF'],
    code: 'SWZ',
    id: 'AF_SWZ',
    name: 'Swaziland'
  },
  {
    regions: ['AF'],
    code: 'TGO',
    id: 'AF_TGO',
    name: 'Togo'
  },
  {
    regions: ['AF', 'NAF'],
    code: 'TUN',
    id: 'AF_TUN',
    name: 'Tunisia'
  },
  {
    regions: ['AF'],
    code: 'TZA',
    id: 'AF_TZA',
    name: 'Tanzania'
  },
  {
    regions: ['AF'],
    code: 'UGA',
    id: 'AF_UGA',
    name: 'Uganda'
  },
  {
    regions: ['AF'],
    code: 'ZWE',
    id: 'AF_ZWE',
    name: 'Zimbabwe'
  },
  {
    regions: ['OECD', 'OC', 'APAC'],
    code: 'AUS',
    id: 'OC_AUS',
    name: 'Australia'
  },
  {
    regions: ['OC', 'APAC'],
    code: 'FJI',
    id: 'OC_FJI',
    name: 'Fiji'
  },
  {
    regions: ['AF'],
    code: 'ZAF',
    id: 'AF_ZAF',
    name: 'South Africa'
  },
  {
    regions: ['AF'],
    code: 'ZMB',
    id: 'AF_ZMB',
    name: 'Zambia'
  },
  {
    regions: ['OC', 'APAC'],
    code: 'NCL',
    id: 'OC_NCL',
    name: 'New Caledonia'
  },
  {
    regions: ['OECD', 'OC', 'APAC'],
    code: 'NZL',
    id: 'OC_NZL',
    name: 'New Zealand'
  },
  {
    regions: ['OC', 'APAC'],
    code: 'PNG',
    id: 'OC_PNG',
    name: 'Papua New Guinea'
  },
  {
    regions: ['OC', 'APAC'],
    code: 'SLB',
    id: 'OC_SLB',
    name: 'Solomon Islands'
  },
  {
    regions: ['OC', 'APAC'],
    code: 'VUT',
    id: 'OC_VUT',
    name: 'Vanuatu'
  },
  {
    regions: ['EU', 'EUS'],
    code: 'ALB',
    id: 'EU_ALB',
    name: 'Albania'
  },
  {
    regions: ['EU', 'OECD', 'EUW'],
    code: 'AUT',
    id: 'EU_AUT',
    name: 'Austria'
  },
  {
    regions: ['EU', 'OECD', 'EUW'],
    code: 'BEL',
    id: 'EU_BEL',
    name: 'Belgium'
  },
  {
    regions: ['EU', 'EUE'],
    code: 'BGR',
    id: 'EU_BGR',
    name: 'Bulgaria'
  },
  {
    regions: ['EU', 'EUS'],
    code: 'BIH',
    id: 'EU_BIH',
    name: 'Bosnia and Herzegovina'
  },
  {
    regions: ['EU', 'EUE'],
    code: 'BLR',
    id: 'EU_BLR',
    name: 'Belarus'
  },
  {
    regions: ['EU', 'OECD', 'EUW'],
    code: 'CHE',
    id: 'EU_CHE',
    name: 'Switzerland'
  },
  {
    regions: ['EU', 'OECD', 'EUE'],
    code: 'CZE',
    id: 'EU_CZE',
    name: 'Czech Republic'
  },
  {
    regions: ['EU', 'OECD', 'EUW'],
    code: 'DEU',
    id: 'EU_DEU',
    name: 'Germany'
  },
  {
    regions: ['EU', 'OECD', 'EUW', 'NRD'],
    code: 'DNK',
    id: 'EU_DNK',
    name: 'Denmark'
  },
  {
    regions: ['EU', 'OECD', 'EUS'],
    code: 'ESP',
    id: 'EU_ESP',
    name: 'Spain'
  },
  {
    regions: ['EU', 'OECD', 'NRD'],
    code: 'EST',
    id: 'EU_EST',
    name: 'Estonia'
  },
  {
    regions: ['EU', 'OECD', 'EUW', 'NRD'],
    code: 'FIN',
    id: 'EU_FIN',
    name: 'Finland'
  },
  {
    regions: ['EU', 'OECD', 'EUW', 'EUS'],
    code: 'FRA',
    id: 'EU_FRA',
    name: 'France'
  },
  {
    regions: ['EU', 'OECD', 'EUW'],
    code: 'GBR',
    id: 'EU_GBR',
    name: 'United Kingdom'
  },
  {
    regions: ['EU', 'OECD', 'EUW', 'EUS'],
    code: 'GRC',
    id: 'EU_GRC',
    name: 'Greece'
  },
  {
    regions: ['EU', 'EUS'],
    code: 'HRV',
    id: 'EU_HRV',
    name: 'Croatia'
  },
  {
    regions: ['EU', 'OECD', 'EUE'],
    code: 'HUN',
    id: 'EU_HUN',
    name: 'Hungary'
  },
  {
    regions: ['EU', 'OECD', 'EUW'],
    code: 'IRL',
    id: 'EU_IRL',
    name: 'Ireland'
  },
  {
    regions: ['EU', 'OECD', 'EUW', 'EUS'],
    code: 'ITA',
    id: 'EU_ITA',
    name: 'Italy'
  },
  {
    regions: ['EU', 'OECD', 'EUW', 'NRD'],
    code: 'ISL',
    id: 'EU_ISL',
    name: 'Iceland'
  },
  {
    regions: ['EU'],
    code: 'KOS',
    id: 'EU_KOS',
    name: 'Kosovo'
  },
  {
    regions: ['EU', 'OECD', 'NRD'],
    code: 'LTU',
    id: 'EU_LTU',
    name: 'Lithuania'
  },
  {
    regions: ['EU', 'OECD', 'NRD'],
    code: 'LVA',
    id: 'EU_LVA',
    name: 'Latvia'
  },
  {
    regions: ['EU', 'OECD', 'EUW'],
    code: 'LUX',
    id: 'EU_LUX',
    name: 'Luxembourg'
  },
  {
    regions: ['EU', 'EUE'],
    code: 'MDA',
    id: 'EU_MDA',
    name: 'Moldova'
  },
  {
    regions: ['EU', 'EUS'],
    code: 'MKD',
    id: 'EU_MKD',
    name: 'Macedonia'
  },
  {
    regions: ['EU', 'EUS'],
    code: 'MNE',
    id: 'EU_MNE',
    name: 'Montenegro'
  },
  {
    regions: ['EU', 'OECD', 'EUW'],
    code: 'NLD',
    id: 'EU_NLD',
    name: 'Netherlands'
  },
  {
    regions: ['EU', 'OECD', 'EUW', 'NRD'],
    code: 'NOR',
    id: 'EU_NOR',
    name: 'Norway'
  },
  {
    regions: ['EU', 'OECD', 'EUE'],
    code: 'POL',
    id: 'EU_POL',
    name: 'Poland'
  },
  {
    regions: ['EU', 'OECD', 'EUW', 'EUS'],
    code: 'PRT',
    id: 'EU_PRT',
    name: 'Portugal'
  },
  {
    regions: ['EU', 'EUE'],
    code: 'ROU',
    id: 'EU_ROU',
    name: 'Romania'
  },
  {
    regions: ['EUE', 'EU', 'AS'],
    code: 'RUS',
    id: 'EU_RUS',
    name: 'Russian Federation'
  },
  {
    regions: ['EU', 'EUS'],
    code: 'SRB',
    id: 'EU_SRB',
    name: 'Serbia'
  },
  {
    regions: ['EU', 'OECD', 'EUE'],
    code: 'SVK',
    id: 'EU_SVK',
    name: 'Slovakia'
  },
  {
    regions: ['EU', 'OECD', 'EUS'],
    code: 'SVN',
    id: 'EU_SVN',
    name: 'Slovenia'
  },
  {
    regions: ['EU', 'OECD', 'EUW', 'NRD'],
    code: 'SWE',
    id: 'EU_SWE',
    name: 'Sweden'
  },
  {
    regions: ['EU', 'EUE'],
    code: 'UKR',
    id: 'EU_UKR',
    name: 'Ukraine'
  }
]

export default worldCountries
